<template>
    <div>
        {{ payload.value }}
    </div>
</template>

<script>
export default {
    name: 'DialogMessage',
    props: {
        payload: Object,
    },
};
</script>

<style>
</style>
